import type { VariantProps } from "tailwind-variants";

import type { badgeStyles } from "@/ui2/atoms/Badge";
import { LCSW } from "@/features/notes/(v2)/components/(signature)/constants";
import type { NoteHistoryEvent } from "@/core/types";

import type { NoteHistoryViewAs } from "../types";

export const COSIGNATURE_ACKNOWLEDGEMENT =
  "By co-signing, I acknowledge that I have reviewed the clinical documentation and agree with the plan of care.";

export const DEFAULT_SUPERVISOR_CREDENTIALS = LCSW;

export const NOTE_HISTORY_LABEL_MAP: Record<
  NoteHistoryEvent["cosignature_status"],
  Record<NoteHistoryViewAs, string>
> = {
  pending: { provider: "Pending Co-Sign", supervisor: "Submitted" },
  rejected: { provider: "Returned", supervisor: "Rejected" },
  resubmitted: { provider: "Pending Co-Sign", supervisor: "Resubmitted" },
  signed: { provider: "Complete", supervisor: "Approved" },
} as const;

type BadgeVariant = NonNullable<VariantProps<typeof badgeStyles>["variant"]>;

export const EVENT_TO_VARIANT_MAP: Record<NoteHistoryEvent["cosignature_status"], BadgeVariant> = {
  pending: "warning",
  rejected: "error",
  resubmitted: "warning",
  signed: "success",
} as const;
